function getElementOfType(element, typeAttribute = "player") {
  let target = element;
  while (target && target !== document.body) {
    if (target.getAttribute("type") === typeAttribute) {
      return target;
    }
    target = target.parentElement;
  }
  throw Error(
    `no parent <xx-${typeAttribute}> element found. Ensure that "element" is a child of a <xx-${typeAttribute}>, and that <xx-${typeAttribute}> has a type="${typeAttribute}" attribute`
  );
}
function getChildElementOfType(element, typeAttribute) {
  if (element.hasChildNodes()) {
    for (const child of element.childNodes) {
      if (child instanceof HTMLElement && child.getAttribute("type") === typeAttribute) {
        return child;
      }
    }
  }
  throw Error(
    `no child <xx-${typeAttribute}> element found. Ensure that "element" is a parent of a <xx-${typeAttribute}>, and that <xx-${typeAttribute}> has a type="${typeAttribute}" attribute`
  );
}
function getActionElement(element) {
  let target = element;
  while (target && target !== document.body) {
    if ((target.hasAttribute("action") || "action" in target) && target.tagName !== "form" && !target.hasAttribute("disabled")) {
      return target;
    }
    target = target.parentElement;
  }
}
function getActionFromEvent(event) {
  const actionElement = getActionElement(event.target);
  if (!actionElement) {
    return [void 0, void 0];
  }
  const action = actionElement.getAttribute("action") || actionElement.action;
  const actionEvents = actionElement.getAttribute("action:events")?.split(/,\s?/g) ?? actionElement.actionEvents;
  if (actionEvents && !actionEvents.includes(event.type)) {
    return [void 0, void 0];
  }
  return [action, actionElement.value];
}
function getKeyActionsFromKeyName(key) {
  const activeElement = document.activeElement;
  if (activeElement && key) {
    const action = activeElement.getAttribute(`keyaction:${key.toLowerCase()}`);
    if (action) {
      return [action, activeElement.value];
    }
  }
  return [void 0, void 0];
}
function getPositionFromEvent(element, event) {
  const x = "touches" in event ? event.changedTouches[0].clientX : event.clientX;
  const { left, width } = element.getBoundingClientRect();
  const position = (x - left) / width;
  return Math.min(1, Math.max(0, position));
}
function getCoordinatesFromEvent(event) {
  const x = "touches" in event ? event.changedTouches[0].clientX : event.clientX;
  const y = "touches" in event ? event.changedTouches[0].clientY : event.clientY;
  return [x, y];
}
function getFontSize(element) {
  const style = getComputedStyle(element);
  if (style.fontSize && /\d+(\.\d+)?px/.test(style.fontSize)) {
    return parseFloat(style.fontSize);
  }
  return 0;
}
export {
  getActionElement,
  getActionFromEvent,
  getChildElementOfType,
  getCoordinatesFromEvent,
  getElementOfType,
  getFontSize,
  getKeyActionsFromKeyName,
  getPositionFromEvent
};
